import React from "react";
import { Dialog, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "./AllReviewsModal.css";

const AllReviewsModal = ({
  open,
  onClose,
  reviews,
  customTheme,
  primaryColor,
  headingColor,
  secondaryColor,
  secondaryHeadingColor,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth id="allrev-dialog">
      <div className="allrev-container">
        <div
          className="allrev-header"
          style={{ borderBottom: `1px solid ${customTheme ? primaryColor() + "20" : "#e2e8f0"}` }}
        >
          <span className="allrev-title" style={{ color: customTheme ? headingColor() : "#1a202c" }}>
            All Reviews
          </span>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div className="allrev-body">
          {(!reviews || reviews.length === 0) && (
            <div className="allrev-status">No reviews yet.</div>
          )}

          {reviews && reviews.length > 0 && (
            <ul className="allrev-list">
              {reviews.map((item, i) => (
                <li
                  key={i}
                  className="allrev-item"
                  style={{
                    background: customTheme ? secondaryColor() : "#f8fafc",
                    border: `1px solid ${customTheme ? primaryColor() + "20" : "#e2e8f0"}`,
                  }}
                >
                  {item.suggestion && item.suggestion !== "Not given" && (
                    <p className="allrev-text" style={{ color: customTheme ? secondaryHeadingColor() : "#4a5568" }}>
                      "{item.suggestion}"
                    </p>
                  )}

                  <div className="allrev-meta-row">
                    {item.qualityOfService && (
                      <span
                        className="allrev-badge"
                        style={{
                          background: customTheme ? primaryColor() + "15" : "#eef2f7",
                          color: customTheme ? primaryColor() : "#334155",
                        }}
                      >
                        {item.qualityOfService}
                      </span>
                    )}
                    {typeof item.satisfaction === "number" && (
                      <span className="allrev-rating">{"★".repeat(item.satisfaction)}</span>
                    )}
                  </div>

                  <div className="allrev-author-row">
                    <span className="allrev-author-name" style={{ color: customTheme ? headingColor() : "#2d3748" }}>
                      {item.name}
                    </span>
                    {item.updateDate && (
                      <span className="allrev-author-date">
                        {moment(item.updateDate).locale("en").format("ll")}
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default AllReviewsModal;